import { Component, OnDestroy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadingService } from '@core/services/loading.service';

@Component({
  selector: 'app-ui-organism-global-spinner',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    @if (loading$ | async) {
    <div class="global-spinner-overlay">
      <div class="global-spinner">
        <div class="spinner-circle"></div>
        <div class="spinner-text">Loading...</div>
      </div>
    </div>
    }
  `,
  styles: [
    `
      .global-spinner-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.35);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        animation: global-spinner-fade-in 180ms ease-out;
      }

      @keyframes global-spinner-fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      .global-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
      }

      .spinner-circle {
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      .spinner-text {
        font-size: 1rem;
        color: #333;
        font-weight: 500;
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class UiOrganismGlobalSpinnerComponent implements OnDestroy {
  public readonly loading$: Observable<boolean>;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly loadingService: LoadingService) {
    this.loading$ = this.loadingService.loading$.pipe(takeUntil(this.destroy$));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
